import { Component, OnInit, Input } from "@angular/core";
import { ApirequestService } from "../../../../../shared/services/apirequest.service";
import { MatTableDataSource } from "@angular/material";
import * as moment from "moment/moment";
import { Router } from "@angular/router";
import { FileService } from "src/app/shared/services/file.service";
import * as _ from "lodash";
import choice from "../../../../../shared/choices";

import { CustomSnackBarComponent } from "./../../../../../shared/common/custom-snack-bar/custom-snack-bar.component";
import { ConfirmationDialogService } from "./../../../../../shared/confirmation-dialog/confirmation-dialog.service";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatSnackBar,
} from "@angular/material";
import { AlertService } from "./../../../../../shared/services/alert.service";
import { RepositorySharedService } from "../../study-evidence/form/repository-shared-service/repository-shared.service";

@Component({
  selector: "app-interventions-main",
  templateUrl: "./interventions-main.component.html",
  styleUrls: ["./interventions-main.component.scss"],
})
export class InterventionsMainComponent implements OnInit {
  loading: boolean;
  start_date: string = "";
  end_date: string = "";
  url: string;
  topHeaders: string[] = ["channelGrouping", "acquisition", "behavior"];
  displayedColumns: string[] = [
    "totalUsers",
    "usersWhoEngagedWithPlatform",
    "newUsers",
    "sessions",
    "avgSessionDuration",
    "bounceRate",
  ];
  alldisplayedColumns: string[] = [
    "channelGrouping",
    "totalUsers",
    "usersWhoEngagedWithPlatform",
    "newUsers",
    "sessions",
    "avgSessionDuration",
    "bounceRate",
  ];
  dataSource: MatTableDataSource<any>;

  filterConfigs = [
    {
      url: "interventions/type/",
      targetProperty: "inteventionTypesFilter",
      key: "type",
      label: "Intervention Type",
      selected: "selectedType",
    },
    {
      url: "interventions/delivery-mode/",
      targetProperty: "deliveryModeFiltersList",
      key: "delivery_mode",
      label: "Delivery Mode",
      selected: "selectedDeliveryMode",
    },
    {
      url: "interventions/settings/",
      targetProperty: "settingFiltersList",
      key: "setting",
      label: "Setting",
      selected: "selectedSetting",
    },
    {
      key: "session_duration",
      label: "Session Duration",
      url: "interventions/session/",
      targetProperty: "sessionFiltersList",
      selected: "selectedSessionDuration",
    },
    {
      key: "total_duration",
      label: "Total Duration",
      url: "interventions/duration/",
      targetProperty: "durationFiltersList",
      selected: "selectedTotalDuration",
    },
    {
      key: "session_frequency",
      label: "Frequency Of Sessions",
      url: "interventions/session-frequency/",
      targetProperty: "sessionFrequencyFiltersList",
      selected: "selectedSessionFrequency",
    },
    {
      key: "target_mechanism",
      label: "Target Mechanism",
      url: "interventions/target-mechanism/",
      targetProperty: "targetMechanismFiltersList",
      selected: "selectedTargetMechanism",
    },
    {
      key: "target_behavior",
      label: "Target Behaviour",
      url: "interventions/target-behaviour/",
      targetProperty: "targetBehaviorFiltersList",
      selected: "selectedTargetBehaviour",
    },
  ];

  inteventionTypesFilter = [];
  deliveryModeFiltersList = [];
  settingFiltersList = [];
  sessionFiltersList = [];
  durationFiltersList = [];
  sessionFrequencyFiltersList = [];
  targetMechanismFiltersList = [];
  targetBehaviorFiltersList = [];

  choices = choice;

  selectedType: string;
  selectedDeliveryMode: string;
  selectedSetting: string;
  selectedSessionDuration: string;
  selectedTotalDuration: string;
  selectedSessionFrequency: string;
  selectedTargetMechanism: string;
  selectedTargetBehaviour: string;
  selectedUploadedBy: string;
  searchTerm: string;
  selectedStatus: string;

  filter_url = {};
  page: number;
  total: number;
  page_size: number;
  total_pages: number;

  interventions: any[];

  items = ["All", "Published", "Pending", "Draft"];
  activeIndex: number = 0;

  loading_submit: boolean;
  @Input() user_id: string;
  chosen_user: string;
  user: any;
  @Input() sourceData: any;

  constructor(
    private apirequestService: ApirequestService,
    private router: Router,
    private fileService: FileService,
    public snackBar: MatSnackBar,
    private confirmationDialogService: ConfirmationDialogService,
    public alertService: AlertService,
    public repositorySharedService: RepositorySharedService
  ) {}

  ngOnInit() {
    // let today = new Date();
    this.page = 1;
    this.total = 0;
    this.page_size = 20;
    this.searchTerm = "";
    this.selectedType = "All";
    this.selectedDeliveryMode = "All";
    this.selectedSetting = "All";
    this.selectedSessionDuration = "All";
    this.selectedTotalDuration = "All";
    this.selectedSessionFrequency = "All";
    this.selectedTargetMechanism = "All";
    this.selectedTargetBehaviour = "All";
    this.selectedUploadedBy = "All";
    this.selectedStatus = "All";

    if (this.user_id != undefined && this.user_id != "") {
      this.chosen_user = localStorage.getItem("chosen_user");
    }

    this.user = JSON.parse(localStorage.getItem("auth.user"));
    this.getFilters();
    this.getInterventions();
  }

  getInterventions() {
    this.loading = true;
    let params = `intervention_type=${this.selectedType}&delivery_mode=${this.selectedDeliveryMode}&setting=${this.selectedSetting}&session_duration=${this.selectedSessionDuration}&validity_studies_uploaded=All&session_duration=${this.selectedSessionDuration}&total_duration=${this.selectedTotalDuration}&session_frequency=${this.selectedSessionFrequency}&target_mechanism=${this.selectedTargetMechanism}&target_behavior=${this.selectedTargetBehaviour}&page=${this.page}&page_size=${this.page_size}&data=${this.searchTerm}&status=${this.selectedStatus}&sort_by=popular`;
    if (this.user_id != undefined && this.user_id != "") {
      params = `${params}&uploaded_by=${this.user_id}`;
    } else {
      params = `${params}&uploaded_by=${this.selectedUploadedBy}`;
    }
    this.apirequestService.get("interventions/search/?" + params).subscribe(
      (res) => {
        this.total = res.count;
        this.interventions = res.results;
        // this.page_size = res.page_size;
        this.page = res.current_page;
        this.total_pages = res.total_pages;
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  navigateTo(link: any) {
    console.log(link.toLowerCase().replace(/\s/g, ""));
    this.router.navigate([
      "/statistics/traffic/" + link.toLowerCase().replace(/\s/g, ""),
    ]);
  }

  exportData() {
    var pageSize = 10000;
    this.url =
      "analytics/channels/?start_date=" +
      this.start_date +
      "&end_date=" +
      this.end_date +
      "&export=True";
    this.loading = true;
    this.apirequestService.get(this.url).subscribe(
      (data) => {
        this.loading = false;
        this.fileService.downloadFile(data.file_url);
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  getFilters() {
    this.filterConfigs.forEach((config) => {
      this.apirequestService.get(config.url).subscribe(
        (res) => {
            this[config.targetProperty] = res.results.reverse();
        },
        (error) => {
          console.log(`Error fetching ${config.url}:`, error);
        }
      );
    });
  }

  onSelectChange(item_name: string, event: any) {
    const selectedValue = event.target.value;
    const config = this.filterConfigs.find(
      (filter) => filter.key === item_name
    );
    if (config && config.selected) {
      this[config.selected] = selectedValue;
    }
    console.log("Selected value:", selectedValue);
    console.log("Selected value:", item_name);
    if (item_name == "uploaded_by") {
      this.selectedUploadedBy = selectedValue;
    }

    this.getInterventions();
  }

  formatDate(inputDate) {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const paddedDay = day < 10 ? "0" + day : day;
    const paddedMonth = month < 10 ? "0" + month : month;
    return `${paddedDay}/${paddedMonth}/${year}`;
  }

  isOdd(num: number): boolean {
    return num % 2 !== 0;
  }

  isMultipleOf4(number) {
    return number % 4 === 0;
  }

  onKeyUp(event: any) {
    const enteredValue = event.target.value;
    console.log("Entered value:", enteredValue);
    this.searchTerm = enteredValue;
    this.getInterventions();
  }

  filter_data() {
    this.getInterventions();
  }

  handleClick(index: number) {
    this.activeIndex = index;
    this.selectedStatus = this.items[index];
    this.getInterventions();
  }
  getItem(item: string, i: number) {
    if (i < this.items.length - 1) {
      return ` |`;
    }
    return ``;
  }

  saveAndPublish(destination, action = "APPROVE", id) {
    this.loading_submit = true;
    this.loading_submit = false;
    let msg1 = "Confirm pulling down intervention";
    let msg2 = "Are you sure you want to pull down this intervention?";
    if (this.user.role == "Researcher") {
      msg2 = "Are you sure you want to suggest pull down of this intervention?";
    }
    let msg3 = "Yes pull down";

    if (action == "PUBLISH") {
      msg1 = "Confirm publishing intervention";
      msg2 = "Are you sure you want to publish this intervention?";
      msg3 = "Yes publish";
    }
    this.confirmationDialogService
      .confirm(msg1, msg2, msg3)
      .then((confirmed) => {
        if (confirmed == true) {
          let data = {
            intervention_id: id,
          };
          if (action == "PULL_DOWN") {
            data["action"] = "PULL_DOWN";
          } else if (action == "PUBLISH") {
            data["action"] = "PUBLISH";
          }
          const url = "interventions/submit_for_approval/";
          this.loading_submit = true;
          let msg4 = "Intervention successfully pulled down.";
          if (this.user.role == "Researcher") {
            msg4 =
              "Intervention pulled down suggestion successfully submitted.";
          }
          this.apirequestService
            .post(url, data)
            // .pipe(first())

            .subscribe(
              (data) => {
                // this.id = data.id;
                this.snackBar.openFromComponent(CustomSnackBarComponent, {
                  data: {
                    message:
                      data == "Intervention successfully pulled down."
                        ? msg4
                        : data ==
                          "Intervention successfully submitted for review"
                        ? data
                        : "Intervention successfully published",
                    action: "Success",
                  },
                  duration: 3 * 1000,
                  panelClass: ["transparent-snack-bar"],
                });
                this.loading_submit = false;
                this.getInterventions();
              },
              (error) => {
                this.alertService.error(error, "");
                this.loading_submit = false;
              }
            );
        }
      });
  }

  public openConfirmationDialog(id) {
    this.confirmationDialogService
      .confirm(
        "Confirm Approval",
        "Are you sure you want to approve this intervention for publishing?"
      )
      .then((confirmed) => {
        if (confirmed == true) {
          const data = {
            intervention_id: id,
            status: "approved",
            comments: "Approved",
            // 'action': 'PUBLISH'
          };
          const url = "interventions/approve_reject_intervention/";
          this.apirequestService.post(url, data).subscribe(
            (res) => {
              this.snackBar.openFromComponent(CustomSnackBarComponent, {
                data: {
                  message: res.message,
                  action: "Success",
                },
                duration: 3 * 1000,
                panelClass: ["transparent-snack-bar"],
              });
              // this.loading = false;
              this.getInterventions();
            },
            (error) => {
              console.log(error);
              // this.loading = false;
            }
          );
        }
      })
      .catch(() =>
        console.log(
          "User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)"
        )
      );
  }

  attachStudyToIntervention(intervention: any) {
    console.log("ADD CLICKED");
    this.repositorySharedService.sendData(intervention);
    let dialogRef = this.sourceData.dialogRef;
    dialogRef.close();
  }
}
